import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

const GlobeIcon = () => (
  <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const ChevronIcon = () => (
  <svg className={styles.chevron} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const LANGUAGES = [
  { code: 'en', label: 'ENG', name: 'English' },
  { code: 'ru', label: 'RU', name: 'Russian' },
  { code: 'de', label: 'DE', name: 'German' },
  { code: 'fr', label: 'FR', name: 'French' },
  { code: 'sv', label: 'SV', name: 'Swedish' },
];

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const langCode = (i18n.language || 'en').split('-')[0];
  const currentIdx = LANGUAGES.findIndex((l) => l.code === langCode);
  const current = LANGUAGES[currentIdx >= 0 ? currentIdx : 0];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className={styles.wrapper} ref={containerRef}>
      <button
        type="button"
        className={`${styles.btn} ${isOpen ? styles.btnOpen : ''}`}
        onClick={() => setIsOpen((o) => !o)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-label="Select language"
      >
        <GlobeIcon />
        <span className={styles.label}>{current.label}</span>
        <ChevronIcon />
      </button>
      {isOpen && (
        <ul className={styles.dropdown} role="listbox">
          {LANGUAGES.map((lang) => (
            <li key={lang.code} role="option" aria-selected={lang.code === langCode}>
              <button
                type="button"
                className={`${styles.option} ${lang.code === langCode ? styles.optionActive : ''}`}
                onClick={() => handleSelect(lang.code)}
              >
                {lang.label} — {lang.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LanguageSwitcher;
